<template>
    <modal @modal-close="handleClose">

        <div class="modal-wrapper">

            <CloseButton @click="handleClose" />

            <div class="modal-content">

                <input
                    v-model="query"
                    class="w-full h-12 form-input form-control form-input-bordered text-80 flex-1 mb-4"
                    :placeholder="$t('Search here...')"
                />

                <div class="border-50 border rounded-lg overflow-hidden" style="height: 320px;">
                    <div class="overflow-y-auto" style="height: 100%;">

                        <div
                            v-for="resp in filteredResponses"
                            class="flex items-center h-12 list-item px-4"
                            @click.prevent="handleClick(resp.uuid)"
                        >

                            <Checkbox
                                v-if="multiple"
                                class="mr-6"
                                :checked="temporaryResponse.includes(resp.uuid)"
                            />

                            <div class="flex-1" :class="{
                                    'text-primary': temporaryResponse.includes(resp.uuid),
                                    'font-semibold': temporaryResponse.includes(resp.uuid),
                                }">
                                {{ resp.title }}
                            </div>

                        </div>

                    </div>
                </div>
            </div>

            <div class="modal-actions-outer-wrapper">
                <div class="modal-actions-inner-wrapper">

                    <button
                        type="button"
                        class="modal-actions-secondary"
                        @click.prevent="handleClose"
                    >
                        {{ $t('Cancel') }}
                    </button>

                    <button
                        v-if="multiple"
                        type="button"
                        class="modal-actions-primary"
                        @click.prevent="handleSave"
                    >
                        {{ $t('Save') }}
                    </button>

                </div>
            </div>

        </div>

    </modal>
</template>

<style scoped>
    .list-item + .list-item {
        border-top: 1px solid #ddd;
    }
</style>

<script>
    import Checkbox from '@/components/Index/Checkbox.vue';
    import CloseButton from '@/components/Modals/CloseButton.vue';

    export default {

        components: { Checkbox, CloseButton },

        props: {
            responses: {
                type: Array,
                required: true,
            },
            response: {
                required: true,
            },
            multiple: {
                type: Boolean,
                required: true,
            },
        },

        data: () => ({
            temporaryResponse: [],
            query: '',
        }),

        computed: {
            filteredResponses() {
                const query = this.query.toLowerCase().trim();
                if (query.length > 0) {
                    return this.responses
                        .filter((response) => response.title.toLowerCase().indexOf(query) !== -1);
                }
                return this.responses;
            },
        },

        created() {
            if (this.response && this.response.length > 0) {
                this.temporaryResponse = JSON.parse(JSON.stringify(this.response));
            }
        },

        methods: {
            handleClose() {
                this.$emit('close');
            },

            handleSave() {
                this.$emit('save', this.temporaryResponse);
            },

            handleClick(value) {
                if (this.multiple) {
                    const index = this.temporaryResponse.indexOf(value);
                    if (index > -1) {
                        this.temporaryResponse.splice(index, 1);
                    } else {
                        this.temporaryResponse.push(value);
                    }
                } else {
                    // if the user clicks on the selected item, we unselect that item
                    if (this.temporaryResponse.length === 1 && this.temporaryResponse[0] === value) {
                        this.temporaryResponse = [];
                    } else {
                        this.temporaryResponse = [value];
                    }
                    this.handleSave();
                }
            },

        },

    };
</script>
